import { type ReactNode } from "react";

function DescParagraph(params: {
  children: ReactNode;
  className?: string;
  text?: "black" | "white";
}) {
  return (
    <p
      style={{ color: params.text === "black" ? "#888" : "rgb(136,136,136)" }}
      className={` text-[16px] leading-[1.2] tracking-[-0.48px] font-normal ${params.className}`}
    >
      {params.children}
    </p>
  );
}

export default DescParagraph;
